import { isPlatformBrowser } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, PLATFORM_ID, provideZoneChangeDetection } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { errorsInterceptor } from './@core/interceptors/errors.interceptor';
import { tokenInterceptor } from './@core/interceptors/token.interceptor';
import { CustomerConfigService } from './@core/services/customer-config.service';
import { routes } from './app.routes';
import { skyLara } from './app.theme';

function initializeApp(customerConfigService: CustomerConfigService, platformId: string): () => Promise<void> {
  if (isPlatformBrowser(platformId)) {
    return () => customerConfigService.getCustomerConfigFromBE();
  }
  return () => Promise.resolve();
}

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    ConfirmationService,
    DialogService,
    DynamicDialogConfig,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([tokenInterceptor, errorsInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: skyLara,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [CustomerConfigService, PLATFORM_ID],
      multi: true,
    },
    importProvidersFrom(NgxDaterangepickerMd.forRoot()),
  ],
};
